import type { Channel } from 'stream-chat';

/* Returns an array of user IDs excluding the current user */
const getOtherParticipants = (channel: Channel, currentUserId: string) => {
  if (!channel.state?.members) return [];
  return Object.values(channel.state.members)
    .filter(m => m.user?.id !== currentUserId)
    .map(member => ({ ...member, ...member.user }));
};

export default getOtherParticipants;
